export enum Stage {
  Start,
  Phone,
  Varify,
}

export const COUNTDOWN = 45;
